export default __webpack_public_path__ + "static/media/folder-open-icon.b3031671.svg";